import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

function SectionInfo({ section }) {
  return (
    <MDBox>
      <MDBox mb={1}>
        <MDTypography variant="h3" fontWeight="bold" color="white" sx={{ backgroundColor: section.color, padding: "2px 8px", borderRadius: "4px" }}>
          {section.name}
        </MDTypography>
      </MDBox>

      <MDBox mt={3} mb={1} ml={0.5}>
        <MDTypography variant="button" fontWeight="regular" color="text">
          Descripción
        </MDTypography>
      </MDBox>
      <MDBox component="ul" m={0} pl={4} mb={2}>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            {section.description}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Orden: {section.order}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Estado: {section.is_active ? "Activo" : "Inactivo"}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

SectionInfo.propTypes = {
  section: PropTypes.object.isRequired,
};

export default SectionInfo;
